<template>
  <div id="app">
    <MyNav v-show="pageShow" />
    <Aside v-show="pageShow" />
    <router-view />
    <Footer v-show="pageShow" />
  </div>
</template>

<script>
import MyNav from "@/components/MyNav.vue";
import Footer from "@/components/Footer.vue";
import Aside from "@/components/Aside.vue";
import { getBannerConfigApi } from "@/apis/index.js";

export default {
  name: "Home",
  components: {
    MyNav,
    Footer,
    Aside,
  },
  data() {
    return {
      pageShow: true,
      companyConfig: {},
    };
  },
  watch: {
    // 监听路由变化
    $route(to) {
      if (to.path == "/login" || to.path == "/register") {
        this.pageShow = false;
      } else {
        this.pageShow = true;
      }
    },
  },
  beforeMount() {
    getBannerConfigApi()
      .then((res) => {
        localStorage.setItem("imgUrlList", JSON.stringify(res.result));
      })
      .catch((err) => {
        this.$message.error(err.message);
      });
  },
  mounted() {
    // 初始化设置 html 字体大小
    this.setHtmlFontSize();
    // 窗口大小变化时重新计算
    window.addEventListener("resize", this.setHtmlFontSize);
  },
  created() {},
  methods: {
    setHtmlFontSize() {
      // 获取屏幕分辨率（宽度）
      const screenWidth = window.screen.width;
      let fontSize = 16; // 默认 16px

      // 根据分辨率自动调整
      if (screenWidth <= 1440) {
        fontSize = 14;
      } else {
        fontSize = 16;
      }

      // 赋值给 html 根标签
      document.documentElement.style.fontSize = fontSize + "px";
    },
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
}
html {
  font-size: 16px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
